import React, { useState } from 'react'
import style from "./style.module.css";
import css from "classnames";

export default function Alert({ children, type, message }) {

    const [isShow, setIsShow] = useState(true);
    const renderElAlert = function () {
        return React.cloneElement(children);
    };
    const handleClose = (e) => {
    e.preventDefault();
    setIsShow(false);
    };
    

    return (
    <div className={css(style.container, !isShow && style.hide)}>
    <div className={css(style.alert, style[type])}>
      <span className={style.closebtn} onClick={handleClose}>
        &times;
      </span>
      {children ? renderElAlert() : message}
    </div>
    </div>
  );
}